import { Fragment, useRef, useState } from 'react';
import { type IProduct } from '@recargas-dominicanas/core/types';
import { ProductsApi } from '@recargas-dominicanas/core/api';
import { Menu } from '@recargas-dominicanas/core/components';
import { Cell } from '@recargas-dominicanas/core/components';
import { TableRow } from '@recargas-dominicanas/core/components';
import { CellIcon } from '@recargas-dominicanas/core/components';
import { CellImage } from '@recargas-dominicanas/core/components';
import { useProductStore } from '../../../store/productStore';
import { MenuOption } from '../../../components/menu-option/menu-option.component';
import { EditProductModal } from '../edit-product-modal/edit-product-modal.component';
import { productCategories, productKeys } from '@recargas-dominicanas/core/constants';
import { formatCurrency } from '@recargas-dominicanas/core/utils';
import { type Style, mergeStyle } from './product-item.module.css';

interface Props {
  product: IProduct,
  style?: Style
}

export function ProductItem(props: Props) {

  const {
    product,
    style: customStyle
  } = props;

  const productStore = useProductStore();

  const style = mergeStyle(customStyle);
  const iconRef = useRef<HTMLDivElement>(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);

  async function handleEnableDisable() {
    await ProductsApi.enable(product.id, !product.enabled);
    await productStore.fetch();
  }
  
  return (
    <Fragment>
      <TableRow>
        <CellImage src={product.image}/>
        <Cell weight='medium' text={product.name}/>
        <Cell text={productKeys[product.key]}/>
        <Cell text={product.type}/>
        <Cell text={productCategories[product.category]}/>
        <Cell 
          weight='bold' 
          color='green' 
          text={
            product.profitType === 'fixed'
              ? formatCurrency(product.profit)
              : product.profit + '%'
          }/>
        {product.enabled 
          ? <Cell weight='medium' color='green' text='Activo'/>
          : <Cell weight='medium' color='gray' text='Inactivo'/>
        }
        <CellIcon refIcon={iconRef} onClick={() => setOpenMenu(true)}/>
      </TableRow>
      <Menu 
        open={openMenu} 
        anchor={iconRef}
        style={style.menu}
        onClose={() => setOpenMenu(false)}>
        <MenuOption 
          text='Editar' 
          onClick={() => setOpenEditModal(true)}/>
        <MenuOption 
          text={product.enabled ? 'Desactivar' : 'Activar'} 
          onClick={handleEnableDisable}/>
      </Menu>
      <EditProductModal
        open={openEditModal}
        product={product}
        onClose={() => setOpenEditModal(false)}/>
    </Fragment>
  );
}
